export default function LogoMark({ light = false }) {
  return (
    <span className={`brand-lockup ${light ? "brand-lockup-light" : ""}`}>
      <span className="brand-symbol" aria-hidden="true">
        <svg viewBox="0 0 36 36" role="presentation">
          <path d="M18 2 31.9 10v16L18 34 4.1 26V10L18 2Z" fill="none" stroke="currentColor" strokeWidth="1.7" />
          <path d="m11 13 7-4 7 4v10l-7 4-7-4V13Z" fill="none" stroke="currentColor" strokeWidth="1.7" />
          <path d="M18 9v18M11 13l14 10M25 13 11 23" fill="none" stroke="currentColor" strokeWidth="1.3" opacity=".75" />
          <circle cx="18" cy="18" r="2.3" fill="currentColor" />
        </svg>
      </span>
      <span className="brand-copy">
        <strong>VORTEX CORE</strong>
        <small>IT SERVICES LLC</small>
      </span>
    </span>
  );
}
